import { useEffect, useRef } from "react";
import { clsx } from "clsx";

import type { CommonProps } from "../components";

export interface TabPanelProps extends CommonProps {
  children?: React.ReactNode;
  id?: string;
  selected?: boolean;
}

export function TabPanel({
  className,
  children,
  selected,
  ...rest
}: TabPanelProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Reset the scroll position when the tab is selected
    if (selected) {
      ref.current?.scrollTo(0, 0);
    }
  }, [selected]);

  return (
    <div
      className={clsx("TabPanel", className)}
      role="tabpanel"
      tabIndex={selected ? 0 : -1}
      ref={ref}
      {...rest}
    >
      {selected && children}
    </div>
  );
}
